export const ApiQuerySpaceAdmins = Symbol('ApiQuerySpaceAdmins');
